// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr.picked {
  background-color: #c6ff9a;
  border: 1px solid !important;
}
i {
  color: #2f14bb !important;
  font-size: 17px !important;
  margin: 0px 3px;
}
div.criminal-history tr.fail {
  border: solid #ec6f6f 2px;
  background-color: #ec6f6f;
}
div.criminal-history tr.review {
  border: solid #fae9af 2px;
  background-color: #fae9af;
}
div.criminal-history tr.ignore {
  border: solid #a0c2f1 2px;
  background-color: #afcefa;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/criminal-records-manager/criminal-records-manager.component.less"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,4BAAA;AADJ;AAGA;EACI,yBAAA;EACA,0BAAA;EACA,eAAA;AADJ;AASA;EACI,yBAAA;EACA,yBAAA;AAPJ;AAUA;EACI,yBAAA;EACA,yBAAA;AARJ;AAWA;EACI,yBAAA;EACA,yBAAA;AATJ","sourcesContent":["@import (reference) url('../../../../assets/ngb-modals.less');\n@import (reference) url('../../../../assets/tables.less');\ntr.picked{\n    background-color: #c6ff9a;\n    border: 1px solid !important;\n}\ni {\n    color: #2f14bb!important;\n    font-size: 17px !important;\n    margin: 0px 3px;\n}\n\n// @rd:#ec6f6f;\n// @yw:#fae9af;\n// @bl:#afcefa;\n// @brd:#a0c2f1;\n\ndiv.criminal-history tr.fail{\n    border: solid @rd 2px;\n    background-color: @rd;\n}\n\ndiv.criminal-history tr.review{\n    border: solid @yw 2px;\n    background-color: @yw;\n}\n\ndiv.criminal-history tr.ignore{\n    border: solid @brd 2px;\n    background-color: @bl;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
